/**
 * Created by luigi on 04/05/17.
 */

$(document).scroll(function () {
    var pageScroll = $(window).scrollTop();
    if (pageScroll > 100 && $(window).width() > 750) {
        $("header").addClass("sticky-ph");
    } else {
        $("header").removeClass("sticky-ph");
    }
});

$(document).ready(function () {

    if($("#checkout").length){
        if($(".help-block")[0]){
            $(".help-block:first").prependTo("#checkout-personal-information-step");
        }
    }

    if (!$('#checkout').length) {
        if ($('#customer-form').length) {
            $('#customer-form .row').each(function (i) {
                $(this).removeClass('row');
                if (i % 2 === 0) {
                    $(this).addClass('clearfix');
                }
            });

            $('footer.form-footer.clearfix').removeClass('clearfix').addClass('col-xs-12');

            $('#customer-form .custom-checkbox').each(function () {
                $(this).parent().parent().prev().addClass('clearfix');
            });

            $('.col-md-8.offset-md-2').each(function () {
                $(this).removeClass('col-md-8 offset-md-2');
                $(this).addClass('col-xs-12- col-md-6');
            });
        }
    }
    $(".chevron__details").click(function () {
        $(this).find("i").each(function () {
            $(this).toggleClass("hidden-xs-up");
        });
    });
    $('#naturalsoul-car1.owl-carousel').owlCarousel({
        items: 1,
        center: true,
        autoplay: false,
        navText: ["<img src='/themes/previa_b2c/assets/img/prev.png'>", "<img src='/themes/previa_b2c/assets/img/next.png'>"],
        responsive: {
            0: {
                dots: true,
                nav: false
            },
            544: {
                dots: true,
                nav: false
            },
            768: {
                dots: false,
                nav: true
            }
        }
    });
    $('#naturalsoul-car2.owl-carousel').owlCarousel({
        autoplay: false,
        navText: ["<img src='/themes/previa_b2c/assets/img/prev.png'>", "<img src='/themes/previa_b2c/assets/img/next.png'>"],
        responsive: {
            0: {
                items: 1,
                startPosition: 0,
                center: true,
                dots: true,
                nav: false
            },
            544: {
                items: 2,
                center: false,
                startPosition: 0,
                dots: true,
                nav: false
            },
            768: {
                items: 3,
                center: true,
                startPosition: 1,
                dots: false,
                nav: true
            }
        }

    });
    $('#blog_product_linked.owl-carousel').owlCarousel({
        items: 4,
        autoplay: false,
        responsive: {
            0: {
                items: 2,
                dots: true,
                nav: false
            },
            544: {
                items: 2,
                dots: true,
                nav: false
            },
            768: {
                items: 4,
                dots: false,
                nav: true
            }
        }
    });
    /*if(typeof BackgroundVideo !== "undefined"){
        const backgroundVideo = new BackgroundVideo('.bv-video', {
                    src: [
                        'http://video-tembo.s3.amazonaws.com/previa/profumo.mp4'
                    ]
                });
        const backgroundVideo2 = new BackgroundVideo('.bv-video-2', {
                    src: [
                        'http://video-tembo.s3.amazonaws.com/previa/kids.mp4'
                    ]
                });
    }*/

    if($("#video-kids").length){
        var video1 = document.getElementById('video-kids');
        video1.addEventListener('click',function(){
            video1.play();
        },false);
    }

     if($("#video-profumo").length) {
         var video2 = document.getElementById('video-profumo');
         video2.addEventListener('click', function () {
             video2.play();
         }, false);
     }

     $('.bv-video-wrap').click(function(){
        $(this).find('video').each(function(){
            this[this.paused ? 'play' : 'pause']();
        });
    });
});


// WEBPACK FOOTER //
// ./js/luigi.js